import { getAxiosInstance } from '../../configs/axios-config';
import { authDetails } from '../../helpers/auth-details';
var constants = require("../../configs/constants");
const ADD_HOMEIMG_PROGRESS = "ADD_HOMEIMG_PROGRESS";
const ADD_HOMEIMG_SUCCESS = "ADD_HOMEIMG_SUCCESS";
const ADD_HOMEIMG_FAILURE = "ADD_HOMEIMG_FAILURE";
const ADD_IMG_ONE_SUCCESS = "ADD_IMG_ONE_SUCCESS";
const SEND_HOME_CASE = "SEND_HOME_CASE";
const HIDE_HMSG_SNACKBAR = "HIDE_HMSG_SNACKBAR";
const LOADING_ONE_IN_PROGRESS = "LOADING_ONE_IN_PROGRESS";

export const hideSnackBarAction = () => { return { type: HIDE_HMSG_SNACKBAR } }
export const loadingOneInProgress = () => { return { type: LOADING_ONE_IN_PROGRESS } }
export const addHomeDetailsInProgress = () => { return { type: ADD_HOMEIMG_PROGRESS } }
export const addHomeDetailsSuccess = (successMessage) => { return { type: ADD_HOMEIMG_SUCCESS, message: successMessage } }
export const addHomeDetailsFailure = (errorMessage) => { return { type: ADD_HOMEIMG_FAILURE, message: errorMessage } }
export const addImageOneSuccess = (imageOne, successMessage) => { return { type: ADD_IMG_ONE_SUCCESS, imageOne: imageOne, successMessage: successMessage } }
export const returnSwitch = (caseData, homeData) => { return { type: SEND_HOME_CASE, caseData: caseData, homeData: homeData } }

// RENDER COMPONENT USING SWITCH CASE
export const renderSwitch = (caseData, homeData) => (dispatch) => {
    dispatch(returnSwitch(caseData, homeData));
};

// HIDE THE MESSAGE SNACKBAR
export const hideSnackBar = () => (dispatch) => {
    dispatch(hideSnackBarAction());
}

// POST HOME IMAGES
export const addHomeImages = (HomeImgData) => (dispatch) => {
    var user = authDetails();
    let axiosInstance = getAxiosInstance();

    dispatch(addHomeDetailsInProgress(HomeImgData));
    return axiosInstance.post(constants.api.POST_HOME_IMGS, {
        titleOne: HomeImgData.titleOne,
        imageOne: HomeImgData.imageOne,
        addedBy: user._id,
        societyId: user._id,
    }).then(function (response) {
        dispatch(addHomeDetailsSuccess(response.data.message));
    }).catch(function (error) {
        dispatch(addHomeDetailsFailure(error.response.data.message));
    });
};

//POST HOME IMAGE ONE
export const uploadFileOne = (HomeImgData) => (dispatch) => {
    dispatch(loadingOneInProgress());
    let bodyFormData = new FormData();
    bodyFormData.append('file', HomeImgData.imageOne);
    const config = {
        headers: { 'content-type': 'multipart/form-data' }
    }

    let axiosInstance = getAxiosInstance();
    return axiosInstance.post(constants.api.UPLOAD, bodyFormData, config
    ).then(function (response) {
        dispatch(addImageOneSuccess(response.data.secureUrl, 'Upload image'));
    }).catch(function (error) {
        dispatch(addHomeDetailsFailure(error.message));
    });
};

export const initialState = {
    message: '',
    inProgress: false,
    open: false,
    choice: 'home',
    imageOne: null,
    homeData: '',
    loadingOne: false,
}

export default (state = initialState, action) => {
    switch (action.type) {
        case ADD_HOMEIMG_PROGRESS:
            return { ...state, inProgress: true };
        case ADD_HOMEIMG_SUCCESS:
            return { ...state, message: action.message, inProgress: false, open: true, choice: 'home', imageOne: null };
        case LOADING_ONE_IN_PROGRESS:
            return { ...state, loadingOne: true };
        case ADD_IMG_ONE_SUCCESS:
            return { ...state, imageOne: action.imageOne, message: action.successMessage, open: true, loadingOne: false };
        case ADD_HOMEIMG_FAILURE:
            return { ...state, message: action.message, inProgress: false, open: true, loadingOne: false, loadingTwo: false, loadingThree: false };
        case SEND_HOME_CASE:
            return { ...state, choice: action.caseData, homeData: action.homeData };
        case HIDE_HMSG_SNACKBAR:
            return { ...state, open: false };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/society/homeImg-reducer.js